import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

export function useTokenPermissions(): [string[], boolean] {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (isAuthenticated) {
        try {
          const accessToken = await getAccessTokenSilently();
          const decodedToken = jwtDecode(accessToken);
          // Assuming permissions are in a "permissions" array in the JWT payload
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const userPermissions: string[] =
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (decodedToken as any).permissions || [];
          setPermissions(userPermissions);
        } catch (err) {
          console.error('Error decoding JWT', err);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchPermissions();
  }, [isAuthenticated, getAccessTokenSilently]);

  return [permissions, isLoading];
}
